export const ARROWS = {
  UP: 'up',
  DOWN: 'down',
  BOTH: 'both',
  NONE: 'none',
};
